import gql from 'graphql-tag';

export const QUERY_BORRADORES = gql(`
  query listaBorradores($criteria: ItemCriteriaInput){
    listaBorradores (criteria: $criteria) {
      results {
        acreedor
        deudor
        fechaModi
        idBorrador
        pendiente
        pagado
        codigoProducto
        token
        tipo
      },
      totalElements
    }
  }
`)

export const QUERY_BORRADOR = gql(`
  query borrador($id: Long!) {
    borrador(id: $id) {
      datos {
        datosAcreedor {
          apellidos,
          codigoPostal,
          direccion,
          email,
          idLegal,
          localidad,
          nombre,
          pais,
          provincia,
          razonSocial,
          sectorActividad,
          codigoActividad,
          telefono,
          tipoEntidad,
          tipoSociedad,
          tipoVia
        },
        datosDeudor {
          apellidos,
          codigoPostal,
          direccion,
          email,
          idLegal,
          localidad,
          nombre,
          pais,
          provincia,
          razonSocial,
          sectorActividad,
          codigoActividad,
          telefono,
          tipoEntidad,
          tipoSociedad,
          tipoVia
        },
        datosDeuda {
          demandaJudicial,
          iban,
          listaImpagos {
            fecha,
            importe,
            listaPagos {
              fecha,
              importe
            }
          },
          observaciones,
          origenDeuda
        },
        datosUsuario {
          actuoEnPropioNombre,
          apellidos,
          nif,
          nombre,
          telefono
        },
        datosConsulta {
          uuidSolicitante
          idLegalDeudor
          representacionPropia
          razonSocialRepresentado
          idLegalRepresentado
          tipo
          origen
          justificacion
          plataforma
        }
      },
      fechaAlta,
      id,
      pagado,
      codigoProducto,
      token,
      apiTransactionId,
      referenciaPago
    }
  }
`)

export const MUTATION_DELETE_DRAFT = gql(`
  mutation borrarBorrador($id: Long) {
    borrarBorrador(id: $id){
      id
    }
  }
`)

export const MUTATION_CREATE_DRAFT = gql(`
  mutation altaBorrador($input: AltaBorradorRequestInput) {
    altaBorrador(altaBorradorRequest: $input){
      datos {
        datosAcreedor {
          apellidos,
          codigoPostal,
          direccion,
          email,
          idLegal,
          localidad,
          nombre,
          pais,
          provincia,
          razonSocial,
          sectorActividad,
          telefono,
          tipoEntidad,
          tipoSociedad,
          tipoVia
        },
        datosDeudor {
          apellidos,
          codigoPostal,
          direccion,
          email,
          idLegal,
          localidad,
          nombre,
          pais,
          provincia,
          razonSocial,
          sectorActividad,
          telefono,
          tipoEntidad,
          tipoSociedad,
          tipoVia
        },
        datosDeuda {
          demandaJudicial,
          iban,
          listaImpagos {
            fecha,
            importe,
            listaPagos {
              fecha,
              importe
            }
          },
          observaciones,
          origenDeuda
        },
        datosUsuario {
          actuoEnPropioNombre,
          apellidos,
          nif,
          nombre,
          telefono
        }
      },
      fechaAlta,
      id,
      pagado
    }
  }
`)

export const MUTATION_EDIT_DRAFT = gql(`
  mutation modificarBorrador($input: ModificarBorradorRequestInput) {
    modificarBorrador(modificarBorradorRequest: $input){
      datos {
        datosAcreedor {
          apellidos,
          codigoPostal,
          direccion,
          email,
          idLegal,
          localidad,
          nombre,
          pais,
          provincia,
          razonSocial,
          sectorActividad,
          telefono,
          tipoEntidad,
          tipoSociedad,
          tipoVia
        },
        datosDeudor {
          apellidos,
          codigoPostal,
          direccion,
          email,
          idLegal,
          localidad,
          nombre,
          pais,
          provincia,
          razonSocial,
          sectorActividad,
          telefono,
          tipoEntidad,
          tipoSociedad,
          tipoVia
        },
        datosDeuda {
          demandaJudicial,
          iban,
          listaImpagos {
            fecha,
            importe,
            listaPagos {
              fecha,
              importe
            }
          },
          observaciones,
          origenDeuda
        },
        datosUsuario {
          actuoEnPropioNombre,
          apellidos,
          nif,
          nombre,
          telefono
        }
      },
      fechaAlta,
      id,
      pagado,
      referenciaPago
    }
  }
`)